/* eslint-disable jsx-a11y/anchor-is-valid */
import { useState } from "react";
import { FaFacebook, FaInstagram, FaTwitter } from "react-icons/fa";
import Navbar from "../../components/navbar/Navbar";
import axios from "axios";
import { useForm } from "react-hook-form";

export const Contact = () => {
  const initialValues = {
    firstName: "",
    lastName: "",
    email: "",
    title: "",
    message: "",
  };
  const { register, handleSubmit, formState: { errors } } = useForm();

  const [msg, setMSg] = useState();
  const [values, setValues] = useState(initialValues);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setValues({
      ...values,
      [name]: value,
    });
  };

  const handleClick = async () => {
      try {
        // eslint-disable-next-line no-unused-vars
        const res = await axios.post(
          process.env.REACT_APP_API_URL + "/contact", values)
          .then(
             setMSg("We receive your message, thank you")
          ).catch((err) => {
            setMSg("Something went wrong please try again!")
          })
      } catch (error) {
        setMSg("Something went wrong please try again!")
      }     
  };


  return (
    <>
      <Navbar />
      <div className="contact flex flex-col md:flex-row md:mx-5 mx-2 lg:mx-44 mt-16 gap-4 pt-10 relative">
        <div className="left flex flex-col flex-1 gap-4 justify-center items-center">
          <h1 className="text-4xl text-primary font-Roboto font-bold mb-10 text-center md:text-start">
            We are so glad to hear from you!
          </h1>
          <h3 className="text-base text-gray-700 font-Roboto font-medium">
            get in touch{" "}
          </h3>
          <div className="flex gap-4">
            <a href="#">
              <FaFacebook className="text-xl text-gray-500 hover:text-gray-700 transition" />
            </a>
            <a href="#">
              <FaInstagram className="text-xl text-gray-500 hover:text-gray-700 transition" />
            </a>
            <a href="#">
              <FaTwitter className="text-xl text-gray-500 hover:text-gray-700 transition" />
            </a>
          </div>
        </div>

        <div className="flex-1">
        <form onSubmit={handleSubmit()} className="flex flex-col gap-5 w-full">
          <div className="flex flex-col gap-1">
          <input {...register("firstName", {required: true})}
            name="firstName"
            onChange={(e) => handleInputChange(e)}
            type="text"
            placeholder="First Name"
            className="placeholder:text-slate-400 bg-white w-full border border-slate-300 rounded-md py-2 px-2 shadow-sm focus:outline-none focus:border-sky-500 focus:ring-sky-500 focus:ring-1 sm:text-sm"
          />
          {errors.firstName && <span className="text-secondary text-sm font-normal">First name is required</span>}
          </div>
          <div className="flex flex-col gap-1">
          <input {...register("lastName", {required: true})}
            name="lastName"
            onChange={(e) => handleInputChange(e)}
            type="text"
            placeholder="Last Name"
            className="placeholder:text-slate-400 bg-white w-full border border-slate-300 rounded-md py-2 px-2 shadow-sm focus:outline-none focus:border-sky-500 focus:ring-sky-500 focus:ring-1 sm:text-sm"
          />
          {errors.lastName && <span className="text-secondary text-sm font-normal">Last name is required</span>}
          </div>
          <div className="flex flex-col gap-1">
          <input {...register("email", {required:true, pattern: /^\S+@\S+$/i})  }
            name="email"
            onChange={(e) => handleInputChange(e)}
            type="email"
            placeholder="Email"
            className="placeholder:text-slate-400 bg-white w-full border border-slate-300 rounded-md py-2 px-2 shadow-sm focus:outline-none focus:border-sky-500 focus:ring-sky-500 focus:ring-1 sm:text-sm"
          />
          {errors.email && <span className="text-secondary text-sm font-normal">Email Address is required</span>}
          </div>
          <div className="flex flex-col gap-1">
          <input {...register("title", {required: true})}
            name="title"
            onChange={(e) => handleInputChange(e)}
            type="text"
            placeholder="Title"
            className="placeholder:text-slate-400 bg-white w-full border border-slate-300 rounded-md py-2 px-2 shadow-sm focus:outline-none focus:border-sky-500 focus:ring-sky-500 focus:ring-1 sm:text-sm"
          />
          {errors.title && <span className="text-secondary text-sm font-normal">Title is required</span>}
          </div>
          <div className="flex flex-col gap-1">
          <textarea {...register("message", {required: true})}
            name="message"
            onChange={(e) => handleInputChange(e)}
            type="text"
            placeholder="Message"
            rows="5"
            className="placeholder:text-slate-400 bg-white w-full border border-slate-300 rounded-md py-2 px-2 shadow-sm focus:outline-none focus:border-sky-500 focus:ring-sky-500 focus:ring-1 sm:text-sm"
          />
          {errors.message && <span className="text-secondary text-sm font-normal">Message is required</span>}
          </div>
          <div className="flex gap-2 items-center mb-2">
            <button 
              onClick={() => handleClick()}
              className="text-lg text-white bg-primary hover:bg-primary-200 py-1 px-10 w-fit  font-Roboto font-semibold drop-shadow-md rounded-md transition"
              type="submit"
            >
              Send
            </button>
            {msg ? (
              <p className="text-primary text-base font-Roboto font-medium">
                {msg}
              </p>
            ) : null}
          </div>
          </form>
        </div>

      </div>
    </>
  );
};
